import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/generarExcelInformePool`, method: 'POST', body: list, token: token})
}